<template>
	<div v-if="is_logged_in"  class="home">
		<div class="col-md-offset-1 col-md-10">

			<!-- DESKTOP -->
			<div  v-if="$mq !== 'mobile'">

                <div class="mb-4 pb-4  panel panel-default drop-shadow">
                    <div class="panel-heading panel-grey text-left">
                        WELCOME
                    </div>
                    &nbsp;<br>
                    <h3>Welcome to FiledSafely</h3>
                    
                    <br>
                    To view files you have sent or received, click on the FILES option on the menu bar above.
                    <br><br>


                </div>

            </div>

			<!-- MOBILE -->
			<div  v-if="$mq === 'mobile'">
                <div class="panel panel-default drop-shadow">

                    <div class="panel-heading panel-grey text-left">
                        WELCOME
                    </div>
                    <h3 style="padding-top:4px;">Welcome to FiledSafely</h3>
                    
                    <div class="" style="clear:both; padding:5px;">
                        View files you have sent or received, 
                        select the FILES option from the app menu.
                        <br><br>
                        You can <b>upload</b> a <b>file</b> or <b>collection of files</b> by clicking on the button below:
                    </div>

                    <div class="" style="padding-top:5px; clear:both;">
                        <center>
                            <button  @click="startUpload()"  
                                     name="button"  type="submit"  
                                     class="btn btn-warning btn-block"  
                                     style="width:320px; border:2px solid black; margin:10px;">
                                <font size=+1><b>Start an Upload</b></font>
                            </button>
                        </center>
                    </div>

                    <div class="" style="clear:both; padding:5px;">
                        {{ upload_start_message }}
                    </div>
                </div>
            </div>
        </div>
	</div>

	<div v-else               class="home">
		<div class="col-md-12">

			<!-- **************************************************
			     * Welcome Panel                                  *
			     ************************************************** -->
			<!-- DESKTOP -->
			<div  v-if="$mq !== 'mobile'">
				<!--
                <div class="panel-heading panel-grey text-left">
					WELCOME
				</div>
				<br>&nbsp;
                -->

				<font size=+4 style="not-text-transform: uppercase; color:white;
                                     text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;">
					<b>
                    <span><span style="color:orange">Protect</span> your copyright and <span style="color:orange">secure</span> your agreements</span>
                    </b>
				</font><br>
				<font size=+2 style="color:lightgrey;
                                     text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;">
                    powered and secured by block-chain technology
				</font>

				<br>&nbsp;

                <div class="text-left" style='margin-left:auto; margin-right:auto; width:80%; 
                                              margin-top:10px; margin-bottom:20px;
                                              padding:10px; font-size:20px;
                                              color:white; text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;'>
                    FiledSafely is the perfect partner for:
                    <center>
                        <table style='width:80%; margin:10px;'>
                            <tr>
                                <td style='width:50%; padding:5px;'>&bull; Confidentiality Agreements</td>
                                <td style='width:50%; padding:5px;'>&bull; Legal agreements and Contracts</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Creative Pitches</td>
                                <td style='padding:5px;'>&bull; Design briefs</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Audio tracks, Music, Lyrics</td>
                                <td style='padding:5px;'>&bull; Scripts and manuscripts</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;' colspan=2>... and many more</td>
                            </tr>
                        </table>
                    </center>
				</div>


				<div v-if="1==1"
                     class="panel panel-default drop-shadow"  style="background-color:rgba(255, 255, 255, 0.8) !important; 
                                                                     margin-left:auto; margin-right:auto; width:80%">
					<center>
						<div class="text-left" style='margin-left:auto; margin-right:auto; padding:10px; font-size:16px;'>
                            <b>Using FiledSafely could not be simpler.</b> 
                            <br><br>
                            To register your data, just email to <b>{{ prot_em }}</b> - and that's it. Simple!
                            <br><br>
                            If you are a new user an account will be automatically created for you.
                            <br><br>
                            Alternatively, for example, if you are sending your data to a publisher, just "cc" <b>{{ prot_em }}</b> when doing so. 
                            This will register and store your data, and FiledSafely will automatically let your recipients know you have protected your data.
                            <br><br>

                            See what our <router-link to="/testimonials">customers say</router-link>!

                            <center>
                                <button  @click="get_started()"  name="button"  type="submit"  class="btn btn-warning btn-block"  style="width:320px; border:2px solid black; margin:10px;">
                                    <font size=+1><b>Click here to get started</b></font>
                                </button>
                            </center>
						</div>
					</center>                            
				</div>

				<br>&nbsp;
				<br>&nbsp;
			</div>

			<!-- MOBILE -->
			<div  v-if="$mq === 'mobile'">
                <!--
				<div class="panel-heading panel-grey text-left">
					WELCOME
				</div>
				<br>&nbsp;
                -->

				<font size=+2 style="text-transform: uppercase; color:white;
                                     text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;">
					<b>
                    <span><span style="color:orange">Protect</span> your copyright and <span style="color:orange">secure</span> your agreements</span>
                    </b>
				</font><br>
				<font size=+0 style="color:lightgrey;
                                     text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;">
                    powered and secured by block-chain technology
				</font>

				<br>&nbsp;

                <div class="text-left" style='margin-left:auto; margin-right:auto; width:90%; 
                                              margin-top:10px; margin-bottom:20px;
                                              padding:10px; font-size:18px;
                                              color:white; text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;'>
                    FiledSafely is the perfect partner for:
                    <center>
                        <table style='width:100%; margin:10px;'>
                            <tr>
                                <td style='width:80%; padding:5px;'>&bull; Confidentiality Agreements</td>
                            </tr>
                            <tr>
                                <td style='width:80%; padding:5px;'>&bull; Legal agreements and Contracts</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Creative Pitches</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Design briefs</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Audio tracks, Music, Lyrics</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Scripts and manuscripts</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;' colspan=2>... and many more</td>
                            </tr>
                        </table>
                    </center>
				</div>
				<br>

				<div v-if="1==1"
                     class="panel panel-default drop-shadow"  style="background-color:rgba(255, 255, 255, 0.8) !important; 
                                                                     margin-left:auto; margin-right:auto; padding:5px;">
					<center>
						<div class="text-left" style='margin-left:auto; margin-right:auto; padding:10px; font-size:16px;'>
                            <b>Using FiledSafely could not be simpler.</b> 
                            <br><br>
                            To register your data, just email to <b>{{ prot_em }}</b> - and that's it. Simple!
                            <br><br>
                            If you are a new user an account will be automatically created for you.
                            <br><br>
                            Alternatively, for example, if you are sending your data to a publisher, just "cc" <b>{{ prot_em }}</b> when doing so. 
                            This will register and store your data, and FiledSafely will automatically let your recipients know you have protected your data.
                            <br><br>

                            See what our <router-link to="/testimonials">customers say</router-link>!

                            <center>
                                <button  @click="get_started()"  name="button"  type="submit"  class="btn btn-warning btn-block"  style="width:260px; border:2px solid black; margin:10px;">
                                    <font size=+1><b>Click here to get started</b></font>
                                </button>
                            </center>
						</div>
					</center>                            
				</div>
			</div>
		</div>
		
	</div>
</template>


<script>
import EventBus from '@/event_bus';					// Event Bus

export default {
	name: 'home_old',

	props: {
	},

    components: {
        EventBus
	},

    data() {
		return {
			env:                        process.env.VUE_APP_ENV,
			api_token:                  '',
            prot_em :                   'dummy@test.com',
			show_section:               3,

            upload_start_message:       '',
            //allowed_types:     [
            //    'image/jpg',
            //    'image/jpeg',
            //    'image/png',
            //    'image/gif',
            //],
		};
	},

	computed: {
		is_logged_in() {
			var status     = false;
			this.api_token = localStorage.getItem('api_token');
			
			if (this.api_token  &&  this.api_token.length == 64) {
				status = true;
			}
				
			return status;
		},

		user() {
			return this.$store.getters.USER;
		},
	},
	
	created() {
	},

	mounted() {
        this.prot_em  = 'prot';
        this.prot_em += 'ect';
        this.prot_em += '@';
        this.prot_em += 'fil';
        this.prot_em += 'edsafely.';
        this.prot_em += 'com';
    },
    
	destroyed() {
	},

	methods: {
		get_started() {
			this.$router.push({ path: 'get_started' });
		},

		async startUpload() {

            //
            const headers = { "Content-Type": "multipart/form-data" };
            var formData  = new FormData();

            formData.append("api_token", this.api_token);
        
            //console.log('uploading');
            try {
                var res = await this.axios.post('api/upload/start', formData, {headers: headers});
                //console.log('upload_start res =', res);

                this.$store.commit("COLLECTION_UPLOAD_ID", res.data.id);
                this.$router.push({ path: 'upload_start' });

            }
            catch(error) {

                var error_msg = '';
                if (error.response) {
                    if (error.response.data.message) {
                        error_msg = error_msg + error.response.data.message + "<br>";	
                    }
                    
                    if (error.response.data.error) {
                        Object.keys(error.response.data.error).forEach(key => {
                            error_msg = error_msg + error.response.data.error[key] + "<br>";

                            // load api errors into client errors
                            this.errors.add({
                                field: key,
                                msg:   error.response.data.error[key],
                            });
                        });
                    }

                    this.$notify({
                        group: "fs_danger",
                        title: "Error",
                        text: error_msg,
                        type: "error"
                    });
                }
                else if (error.message == "Network Error") {
                    localStorage.removeItem('api_token');
                    this.$store.commit("RESET");
                    this.api_token = null;

                    this.$notify({
                        group: "fs_warning",
                        title: "Session has expired",
                        text:  "Please log in again.",
                        type:  "error"
                    });

                    EventBus.$emit('refresh_header_api_token', this.api_token);
                    this.$router.push("/");
                }
                else {
                    console.log('startUpload()  unexpected error: ', JSON.stringify(error));

                    this.$notify({
                        group: "fs_danger",
                        title: "Error",
                        text: "Unexpected error.<br>Suggest logging out and back in again.",
                        type: "error"
                    });
                }

            }
		},
    },
}

</script>
